// src/app/redux/reducers/paramAvantagesSociauxReducer.js

import {
    SET_PARAM_AVANTAGES_LOADING,
    CLEAR_PARAM_AVANTAGES_ERROR,

    FETCH_PARAM_AVANTAGES_REQUEST,
    FETCH_PARAM_AVANTAGES_SUCCESS,
    FETCH_PARAM_AVANTAGES_FAIL,

    CREATE_AV_CAT_SUCCESS,
    UPDATE_AV_CAT_SUCCESS,
    DELETE_AV_CAT_SUCCESS,

    CREATE_AV_REGLE_SUCCESS,
    UPDATE_AV_REGLE_SUCCESS,
    DELETE_AV_REGLE_SUCCESS,

    CREATE_AVANTAGE_SUCCESS,
    UPDATE_AVANTAGE_SUCCESS,
    DELETE_AVANTAGE_SUCCESS,

    UPDATE_AV_CAT_FAIL,
    UPDATE_AV_REGLE_FAIL,
    UPDATE_AVANTAGE_FAIL,
} from "../actions/paramAvantagesActions";

const initialState = {
    loading: false,
    error: null,

    categories: [],
    regles: [],
    avantages: [],
};

export default function paramAvantagesSociauxReducer(state = initialState, action) {
    switch (action.type) {
        case SET_PARAM_AVANTAGES_LOADING:
            return { ...state, loading: action.payload };

        case CLEAR_PARAM_AVANTAGES_ERROR:
            return { ...state, error: null };

        case FETCH_PARAM_AVANTAGES_REQUEST:
            return { ...state, loading: true, error: null };

        case FETCH_PARAM_AVANTAGES_SUCCESS:
            return {
                ...state,
                loading: false,
                error: null,
                categories: action.payload?.categories || [],
                regles: action.payload?.regles || [],
                avantages: action.payload?.avantages || [],
            };

        case FETCH_PARAM_AVANTAGES_FAIL:
            return { ...state, loading: false, error: action.payload };

        // ===== CATEGORIES =====
        case CREATE_AV_CAT_SUCCESS:
            return { ...state, categories: [action.payload, ...state.categories] };

        case UPDATE_AV_CAT_SUCCESS: {
            const updated = action.payload;
            return {
                ...state,
                loading: false,
                categories: (state.categories || []).map((c) => (c.id === updated.id ? updated : c)),
            };
        }

        case DELETE_AV_CAT_SUCCESS:
            return { ...state, categories: state.categories.filter((c) => c.id !== action.payload) };

        // ===== REGLES =====
        case CREATE_AV_REGLE_SUCCESS:
            return { ...state, regles: [action.payload, ...state.regles] };

        case UPDATE_AV_REGLE_SUCCESS: {
            const updated = action.payload;
            return {
                ...state,
                loading: false,
                regles: (state.regles || []).map((r) => (r.id === updated.id ? updated : r)),
            };
        }

        case DELETE_AV_REGLE_SUCCESS:
            return { ...state, regles: state.regles.filter((r) => r.id !== action.payload) };

        // ===== AVANTAGES =====
        case CREATE_AVANTAGE_SUCCESS:
            return { ...state, avantages: [action.payload, ...state.avantages] };

        case UPDATE_AVANTAGE_SUCCESS: {
            const updated = action.payload;
            return {
                ...state,
                loading: false,
                avantages: (state.avantages || []).map((a) => (a.id === updated.id ? updated : a)),
            };
        }

        case DELETE_AVANTAGE_SUCCESS:
            return { ...state, avantages: state.avantages.filter((a) => a.id !== action.payload) };

        // update fail (même style que ton reducer paramConges)
        case UPDATE_AV_CAT_FAIL:
        case UPDATE_AV_REGLE_FAIL:
        case UPDATE_AVANTAGE_FAIL:
            return { ...state, loading: false, error: action.payload };

        default:
            return state;
    }
}
